import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton, RadioGroup, Radio, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CurrencySymbol } from '../../../Utility/Constants'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useHistory, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Loader from '../../../Components/Loader'
import { AmountFormat, CheckAccessFunc, ContentInTooltip } from '../../../Components/CommonFunctions/CommonFunctions'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { localGetItem } from '../../../Utility/Services/CacheProviderService'
export default function AddInsurancePackage() {
    const location = useLocation();
    const PackId = location.state?.PackData || null;
    const PackType = location.state?.PackType;
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [formState, setFormState] = useState({
        searchList: [],
        serviceSearch: '',
        serviceSearchData: null,
        selectedUnit: '',
        packageCode: '',
        packageName: '',
        packageAmount: '',
        serviceName: '',
        serviceAmount: 0,
        PackSugg: [],
        selected_package: null,
        selectedTypeRadio: "Service",
        config_type: PackType || "",
        InsuranceName: null,
        PackId: PackId || null,
        packs_id: null,
        ins_id: null,
    });
    // const [isActive, setIsActive] = useState(true);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [PackageDetail, setPackageDetail] = useState([]);
    const [editingRow, setEditingRow] = useState(null);
    const [editedAmount, setEditedAmount] = useState({});
    const [InsuranceList, setInsuranceList] = useState([])
    const [servicelist, setServiceList] = useState([]);
    const [packageLineItem, setPackageLineItem] = useState(null)
    const [totalPackage, setTotalPackage] = useState(0);
    const [assPackData, setassPackData] = useState([]);
    const [editHead, seteditHead] = useState('');
    let userLogin = JSON.parse(localGetItem('loggedInUserInfo'))
    const [loginInfo, setLoginInfo] = useState(userLogin)
    useEffect(() => {
        if (PackId) {
             getInsurancePackageList(); 
        }
    }, [PackId]);

    useEffect(() => {
        getInsuranceList()
        getPackageList()
    }, [])

    useEffect(() => {
        if(InsuranceList?.length > 0 && formState?.ins_id && formState?.PackId){
            const ins = InsuranceList.find(item => item.insurance_id == formState?.ins_id) || null;
            setFormState((prev) => ({
                ...prev,
                InsuranceName: ins
            }))
        }
    }, [formState?.ins_id, InsuranceList, formState?.PackId])

    useEffect(() => {
        if (formState?.PackSugg.length > 0 && formState?.PackId && formState?.packs_id) {
            let selected = null;

            if (formState.config_type === "Normal") {
                selected = formState.PackSugg.find(
                    (item) => item.package_id == formState.packs_id
                ) || null;
            } else if (formState.config_type === "Assorted") {
                selected = formState.PackSugg.find(
                    (item) => item.assorted_package_id == formState.packs_id
                ) || null;
            }

            if (selected) {
                setFormState((prev) => ({
                    ...prev,
                    selected_package: selected
                }));
            }
        }
    }, [formState.PackSugg, formState.PackId, formState.packs_id, formState.config_type]);

    useEffect(() => {
        if (formState.config_type === "Assorted") {
            const newPackAmount = PackageDetail?.line_items?.reduce((total, item) => {
                const itemTotal = item?.service_data?.reduce(
                    (sum, service) => sum + (parseFloat(service.amount) || 0),
                    0
                );
                return total + itemTotal;
            }, 0);

            setPackageDetail((prev) => ({
                ...prev,
                pack_amount: newPackAmount
            }));
            setTotalPackage(newPackAmount)
        }
    }, [PackageDetail?.line_items]);

    const getInsuranceList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setInsuranceList(response?.data?.data || [])
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    
    const getPackageList = () => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_LIST + "?insurance_config=true")
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setFormState((prev) => ({ ...prev, PackSugg: response?.data?.data }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getInsurancePackageList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_INSURANCE_PACKAGE_CONFIG + "?config_id=" + PackId + "&package_type="+ PackType)
                .then((response) => {
                    if(response.data.status === "success") {
                        if(formState?.config_type == "Normal"){
                            setFormState((prevState) => ({
                                ...prevState,
                                packageCode: response.data.data?.package_code,
                                packageName: response.data.data?.package_name,
                                appliesTo: response.data.data?.apply_for,
                                ins_id: response.data.data?.insurance_id,
                                packs_id: response.data.data?.package_id
                            }));   
                            setTotalPackage(response.data?.data?.package_amount)
                            setPackageDetail(response.data?.data?.line_item)
                        }
                        else{
                            setFormState((prevState) => ({
                                ...prevState,
                                packageCode: response.data.data[0]?.package_code,
                                packageName: response.data.data[0]?.assorted_package_name,
                                appliesTo: response.data.data[0]?.apply_for,
                                ins_id: response.data.data[0]?.insurance_id,
                                packs_id: response.data.data[0]?.assorted_package_id
                            }));   
                            setTotalPackage(response.data?.data[0]?.package_amount)
                            setPackageDetail(response?.data?.data[0])
                        }
                        setisloader(false)
                        
                    }
                }).catch((e) => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                    })
        }
        catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getPackageIndividual = (value = "") => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_PACKAGE_CONFIGURATION + `?get_type=individual&package_id=${value?.package_id || value?.assorted_package_id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const serviceData = response.data.data || [];
                        setServiceList(serviceData);
                        setFormState((prevState) => ({
                            ...prevState,
                            packageCode: response.data.data?.package_code,
                            packageName: response.data.data?.package_name,
                            appliesTo: response.data.data?.apply_for
                        }));
                        // setIsActive(response.data.data?.is_active)
                        setPackageDetail(serviceData?.line_item || [])
                        const totalPackageAmount = serviceData?.line_item.reduce((acc, item) => acc + (item?.service_amount || 0), 0);
                        setTotalPackage(totalPackageAmount);
                        const packageLineItemIds = serviceData?.line_item
                            .map(service => service.package_line_item_id)
                            .filter(id => id !== null && id !== undefined);
                        setPackageLineItem(packageLineItemIds);
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getAssortedData = (value = "") => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.ASS_GET_ASSORTED_PACKAGE + `?billing=${true}&package_id=${value.assorted_package_id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        let List = response?.data?.data[0]
                        setPackageDetail(List || [])
                        setTotalPackage(List?.pack_amount)
                        setFormState((prevState) => ({
                            ...prevState,
                            packageCode: response.data.data[0]?.pack_code,
                            packageName: response.data.data[0]?.pack_name,
                            appliesTo: response.data.data[0]?.module_type
                        }));
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const CommonTickButton = ({ onClick, size }) => (
        <IconButton size="small" onClick={onClick}>
            <CheckBoxIcon color="green" sx={{ fontSize: size, color: "#04b7b1" }} />
        </IconButton>
    );

    const TableHeaderBtns = () => {
        return (
            <Box>
                {/* <Tooltip title="Filter" placement='top' arrow>
                    <IconButton onClick={() => { setFilterOpen(true) }}><FilterAltIcon color='primary' /></IconButton>
                </Tooltip> */}
            </Box>
        )
    }

    const textBox = (label, name, val, width, disable = false, Symbol = null) => {
        const finalValue = val !== undefined && val !== null ? val : "";

        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    autoComplete='off'
                    value={finalValue}
                    id={'id_' + name}
                    sx={{ width: width, marginRight: '1vw', paddingTop: '0.2rem' }}
                    label={label}
                    InputProps={Symbol ? {
                        style: { paddingRight: '0.5vw' },
                        endAdornment:
                            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                                {Symbol === 'rupee' ? CurrencySymbol : '%'}
                            </Typography>
                    } : null}
                    variant="outlined"
                />
            </Box>
        );
    };

    const AddPackageData = () => {
        try {
            if (!formState?.selected_package || !formState?.InsuranceName) {
                return errorMessage('Please Enter All mandatory fields');
            }
            let packageItems = []
            if (formState?.config_type === "Assorted") {
                packageItems = PackageDetail.line_items?.map((item) => {
                    const serviceData = item.service_data?.map((line) => ({
                        assorted_package_items_id: PackId ? line?.assorted_package_items_id : line?.id,
                        amount: line.amount,
                        id: PackId ? line?.id : null
                    })) || [];
                    const totalAmount = serviceData.reduce(
                        (sum, line) => sum + (parseFloat(line.amount) || 0),
                        0
                    );
                    return {
                        package_details_id: null,
                        assorted_package_head_id: item.head_id,
                        amount: totalAmount,
                        service_data: serviceData,
                        id: PackId ? item?.id : null
                    };
                }) || []
            }
            else {
                packageItems = PackageDetail?.map(item => ({
                    package_details_id: item?.package_line_item_id,
                    assorted_package_head_id: null,
                    amount: item?.service_amount,
                    service_data: [],
                    id: item?.id || null,
                }));
            }

            let data = {
                insurance_id: formState?.InsuranceName?.insurance_id,
                insurance_company_name: formState?.InsuranceName?.insurance_name,
                config_type: formState?.config_type,
                package_id: formState?.selected_package?.package_id,
                package_name: formState?.selected_package?.package_name,
                assorted_package_id: formState?.selected_package?.assorted_package_id,
                assorted_package_name: formState?.selected_package?.assorted_package_name,
                total_amount: totalPackage,
                // is_active: isActive,
                line_items: packageItems,
                id: PackId || null
            }


            setisloader(true)
            RestAPIService.create(data, Serviceurls.NEW_INSURANCE_PACKAGE_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        successMessage(response.data.message)
                        history.push("/Settings/NewService/InsurancePackageConfig")
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const Servicetbl = () => {
        return (
            <Box sx={{ width: '40vw', height: '60vh' }}>
                <TableContainer component={Paper} sx={{ height: '60vh' }}>
                    <Table size='small' sx={{ width: '40vw', }} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', width: '25vw' }}>Assorted Service Head</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>Total Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '5vw' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {PackageDetail?.line_items?.length > 0 ? PackageDetail?.line_items?.map((item, i) => (
                                <TableRow sx={{ bgcolor: (editHead === item.service_head) ? '#d9d9d9' : 'white', cursor: 'pointer' }}>
                                    <TableCell sx={{ width: '25vw' }}>
                                        {item.service_head.length > 50 ?
                                            <Tooltip title={item.service_head} placement='top'><Typography fontSize={'1vw'}>{item.service_head.slice(0, 50) + '...'}</Typography></Tooltip> :
                                            <Typography fontSize={'1vw'}>{item.service_head}</Typography>}
                                    </TableCell>
                                    <TableCell sx={{ width: '10vw' }}>
                                        {AmountFormat(
                                            item?.service_data?.reduce((sum, service) => sum + (parseFloat(service.amount) || 0), 0)
                                        )?.replace(`${CurrencySymbol}`, "")}
                                    </TableCell>
                                    <TableCell sx={{ width: '5vw' }}>
                                        <Stack direction="row" alignItems="center" spacing={4}>
                                            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                                <IconButton sx={{ height: '1.5dvw', width: '1.5dvw' }}
                                                    onClick={() => {
                                                        seteditHead(item.service_head);
                                                        setFormState((prev) => ({ ...prev, selectedTypeRadio: item?.assorted_head_type ? item?.assorted_head_type : 'Service' }))
                                                    }}>
                                                    <Box component={'img'} src={ImagePaths.LabViewButton.default} height={'1.5dvw'} width={'1.5dvw'} />
                                                </IconButton>
                                            </Stack>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            )) : (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">{'No Records To Be Shown'}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )
    }

    const SubServicetbl = () => {
        return (
            <Box sx={{ width: '52vw', height: '60vh' }}>
                <Box sx={{ height: '8vh', paddingTop: '.5vw', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <RadioGroup row value={formState.selectedTypeRadio}
                        onChange={(e) => {
                            let value = e.target.value

                        }}
                    >
                        <FormControlLabel value="Service" control={<Radio size='small' disabled={true} />} label="Service" />
                        <FormControlLabel value="External Drug" control={<Radio size='small' disabled={true} />} label="External Drug" />
                        {loginInfo?.show_assorted_inhouse_drug && <FormControlLabel value="Inhouse Drug" control={<Radio size='small' disabled={true} />} label="InHouse Drug" />}
                    </RadioGroup>
                </Box>
                <TableContainer component={Paper} sx={{ height: '52vh' }}>
                    <Table size='small' sx={{ width: '52vw' }} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', width: '35%', padding: '0.5vw' }}>{formState.selectedTypeRadio === 'Service' ? 'Service Head' : 'Drug Name'}</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '35%', padding: '0.5vw' }}>{formState.selectedTypeRadio === 'Service' ? 'Service Name' : 'Qty'}</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%', padding: '0.5vw' }}>Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%', padding: '0.5vw' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {PackageDetail?.line_items?.length > 0 &&
                                PackageDetail?.line_items
                                    ?.filter(item => item?.service_head === editHead)
                                    .map((item) =>
                                        item?.service_data?.map((data, index) => {
                                            const isEditing = editingRow?.head === item.service_head && editingRow?.id === data.id;

                                            return (
                                                <TableRow key={data.id}>
                                                    <TableCell sx={{ width: '15vw', padding: '0.5vw' }}>
                                                        {formState.selectedTypeRadio === 'Service'
                                                            ? ContentInTooltip(data.service_type || "-", 25)
                                                            : ContentInTooltip(data.service_name || "-", 25)}
                                                    </TableCell>

                                                    <TableCell sx={{ width: '6vw', padding: '0.5vw' }}>
                                                        {formState.selectedTypeRadio === 'Service'
                                                            ? ContentInTooltip(data.service_name || "-", 25)
                                                            : (data.quantity || '-')}
                                                    </TableCell>

                                                    <TableCell sx={{ width: '6vw', padding: '0.5vw' }}>
                                                        {isEditing ? (
                                                            <TextField
                                                                size="small"
                                                                value={editedAmount[data.id] ?? data.amount}
                                                                onChange={(e) => {
                                                                     const val = e.target.value;
                                                                    if (val === '' || /^[0-9]*\.?[0-9]*$/.test(val)) {
                                                                        setEditedAmount((prev) => ({
                                                                            ...prev,
                                                                            [data.id]: val
                                                                        }));
                                                                    }
                                                                }
                                                                }
                                                                sx={{ width: '6vw', fontSize: '0.9vw' }}
                                                            />
                                                        ) : (
                                                            AmountFormat(data.amount || 0)?.replace(`${CurrencySymbol}`, "")
                                                        )}
                                                    </TableCell>

                                                    <TableCell sx={{ width: '4vw', padding: '0.5vw' }}>
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            {isEditing ? (
                                                                <CommonTickButton
                                                                    size="1.85vw"
                                                                    onClick={() => {
                                                                        const newAmount = parseFloat(editedAmount[data.id]) || 0;

                                                                        const updatedPackageDetail = PackageDetail?.line_items.map((dataRow) => {
                                                                            if (dataRow.service_head !== item.service_head) return dataRow;

                                                                            return {
                                                                                ...dataRow,
                                                                                service_data: dataRow.service_data.map((s) =>
                                                                                    s.id === data.id ? { ...s, amount: newAmount } : s
                                                                                ),
                                                                            };
                                                                        });
                                                                        const updatedLineItems = {
                                                                            ...PackageDetail,
                                                                            line_items: updatedPackageDetail
                                                                        };
                                                                        setPackageDetail(updatedLineItems);
                                                                        setEditingRow({ head: null, id: null });
                                                                    }}
                                                                />
                                                            ) : (
                                                                <CommonEditButton
                                                                    size="1.5vw"
                                                                    onClick={() => {
                                                                        setEditingRow({ head: item.service_head, id: data.id });
                                                                        setEditedAmount((prev) => ({
                                                                            ...prev,
                                                                            [data.id]: data.amount
                                                                        }));
                                                                    }}
                                                                />
                                                            )}
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                    )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )
    }

    const AssortTableView = () => {
        return (
            <Box component={'div'} sx={{ height: '65vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    {Servicetbl()}
                    {SubServicetbl()}
                </Box>
            </Box>
        )
    }

    const tableView = () => {
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText renderComponent={TableHeaderBtns} />
                </Box>
            )
        }


        PackageDetail?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'service_head', headerName: 'Service Head Details', flex: 0.30,
                renderCell: (params) => {
                    const serviceHeadName = params.row?.service_head_name || params.row?.service_head;
                    return (serviceHeadName ? serviceHeadName?.length > 35 || params.row.service_head_code?.length > 35 ?
                        <Tooltip placement="top" title={`${params.row?.service_head_code ? params.row?.service_head_code + ' - ' : ''}${serviceHeadName}`}><Typography fontSize={'0.9vw'}>{params.row?.service_head_code ? params.row?.service_head_code + ' - ' : ''}{serviceHeadName.slice(0, 33) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row?.service_head_code ? params.row?.service_head_code + ' - ' : ''}{serviceHeadName}</Typography> : '-')
                }
            },
            {
                field: 'service_name', headerName: 'Service Name Details', flex: 0.30,
                renderCell: (params) => (params.row?.service_name ? params.row?.service_name?.length > 35 || params.row?.service_code?.length > 35 ?
                    <Tooltip placement="top" title={`${params.row?.service_code ? params.row?.service_code + ' - ' : ''}${params.row?.service_name}`}><Typography fontSize={'0.9vw'}>{params.row?.service_code ? params.row?.service_code + ' - ' : ''}{params.row?.service_name.slice(0, 33) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row?.service_code ? params.row?.service_code + ' - ' : ''}{params.row?.service_name}</Typography> : '-')
            },
            {
                field: 'service_amount',
                headerName: 'Service Amount',
                flex: 0.25,
                renderCell: (params) => {
                    const rowId = params.id;
                    const isEditing = editingRow === rowId;

                    return isEditing ? (
                        <TextField
                            size="small"
                            value={editedAmount[rowId] ?? params.row?.service_amount}
                            onChange={(e) => {
                            const val = e.target.value;
                            if (val === '' || /^[0-9]*\.?[0-9]*$/.test(val)) {
                                setEditedAmount((prev) => ({
                                    ...prev,
                                    [rowId]: e.target.value
                                }));
                            }
                            }}
                             sx={{
                                width: '8vw',
                                '& .MuiInputBase-root': {
                                    height: '1.9rem',       // total height
                                    fontSize: '0.8rem',     // smaller text
                                },
                                '& .MuiInputBase-input': {
                                    padding: '2px 6px',     // tighter padding
                                }
                            }}
                        />
                    ) : (
                        <Typography fontSize="0.9vw">
                            {params.row?.service_amount
                                ? AmountFormat(params.row?.service_amount)?.replace(`${CurrencySymbol}`, "")
                                : "0.00"}
                        </Typography>
                    );
                }
            },
            {
                field: 'action',
                headerName: 'Action',
                flex: 0.15,
                renderCell: (params) => {
                    const rowId = params.id;
                    const isEditing = editingRow === rowId;

                    return (
                        <Stack direction="row" spacing={1} alignItems="center">
                            <CommonEditButton
                                size="1.5vw"
                                onClick={() => {
                                    setEditingRow(rowId);
                                    setEditedAmount((prev) => ({
                                        ...prev,
                                        [rowId]: params.row?.service_amount
                                    }));
                                }}
                            />
                            {isEditing && (
                                <CommonTickButton
                                    size="1.85vw"
                                    onClick={() => {
                                        const newAmount = parseFloat(editedAmount[rowId]) || 0;
                                        setPackageDetail((prev) => {
                                            const updatedList = prev.map((item) =>
                                                item.sno === rowId ? { ...item, service_amount: newAmount } : item
                                            );

                                            const newTotal = updatedList.reduce(
                                                (sum, row) => sum + (parseFloat(row?.service_amount) || 0),
                                                0
                                            );
                                            setTotalPackage(newTotal);
                                            return updatedList;
                                        });

                                        setEditingRow(null);
                                    }}
                                />
                            )}
                        </Stack>
                    );
                }
            }

        ]

        return (
            <Box sx={{ height: '58vh', marginTop: '.5vw' }}>
                <DataGrid
                    rows={PackageDetail?.length > 0 ? PackageDetail : []}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }
    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const prevent = () => {
        history.push("/Settings/NewService/InsurancePackageConfig")
    }

    return (
        <Box component={'div'} sx={{ height: '85vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => prevent()}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Insurance Configuration'}</Typography>
            </Box>
            <Box component={'div'} sx={{ height: '18vh', width: '93vw', backgroundColor: 'white', marginTop: "1vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Insurance Package Configuration'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", alignItems: "center", height: "8vh", paddingLeft: "0.5vw" }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "8vh", paddingLeft: "0.5vw" }}>
                        <Autocomplete
                            clearIcon
                            size='small'
                            sx={{ width: '21dvw', pt: '0.2rem' }}
                            options={InsuranceList}
                            disabled={formState.PackId != null}
                            getOptionLabel={(option) => option?.insurance_name || option}
                            // isOptionEqualToValue={(option, value) => option.insurance_id === value.insurance_id}
                            value={formState?.InsuranceName}
                            onChange={(e, newValue) => {
                                setFormState((prev) => ({
                                    ...prev,
                                    InsuranceName: newValue
                                }))
                            }}
                            renderInput={(params) => <TextField {...params} label={"Select Insurance Name"} sx={{ width: "20vw", marginRight: '0.3vw' }} />}
                        />
                        <Autocomplete
                            size='small'
                            sx={{ width: '17dvw', pt: '0.2rem', marginRight: "1dvw" }}
                            options={formState?.PackSugg}
                            disabled={formState.PackId != null}
                            getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name ? `${option.template_name} - Template` : option?.package_name ? `${option?.package_name ?? ""} - Package` : `${option?.assorted_package_name ?? ""} - Assorted`}
                            value={formState?.selected_package}
                            onChange={(e, newValue) => {
                                setFormState((prev) => ({
                                    ...prev,
                                    selected_package: newValue || null,
                                    config_type: newValue?.assorted_package_id ? "Assorted" : "Normal"
                                }))
                                setPackageDetail([])
                                if (newValue?.assorted_package_id) {
                                    getAssortedData(newValue)
                                }
                                else if (newValue?.package_id) {
                                    getPackageIndividual(newValue)
                                }
                            }}
                            renderInput={(params) => <TextField
                                {...params}
                                label='Select Assorted/Package'
                                InputProps={{
                                    ...params.InputProps, emed_tid: 'ser_temp_pack'
                                }}
                            />}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    {...props}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        justifyContent: "flex-start",
                                        width: "100%",
                                        textAlign: "left",
                                    }}
                                >
                                    <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }} >
                                        {`${option?.template_name || option?.package_name || option?.assorted_package_name || "-"}${(option?.assorted_package_amount || option?.assorted_package_amount === 0 || option?.package_amount || option?.package_amount === 0) ? ` - ${AmountFormat(option?.assorted_package_amount || option?.package_amount || 0)}` : ""}`}
                                    </Typography>
                                    <Typography
                                        fontSize=".8vw"
                                        fontWeight="bold"
                                        sx={{ width: "100%", textAlign: "left" }}
                                        color={option?.template_name ? "#29B6F6"
                                            : option?.package_name ? "#1E972A"
                                                : option?.assorted_package_name ? "blue"
                                                    : "inherit"}
                                    >
                                        {option?.template_name ? "Template"
                                            : option?.package_name ? "Package"
                                                : option?.assorted_package_name ? 'Assorted'
                                                    : ""}
                                    </Typography>
                                </Box>
                            )}
                        />
                        {textBox("Applies To", 'appliesTo', formState?.appliesTo, '15vw', true)}
                        {textBox("Total Package Amount", 'packageAmount', totalPackage?.toFixed(2), '15vw', true)}
                        {/* <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' />} disabled={!PackId} label={"Active"} /> */}
                        <Button size='small' variant='contained' disabled={!PackageDetail} sx={{ textTransform: 'capitalize', width: '5vw', marginRight: '0.5vw' }} onClick={() => { AddPackageData() }}>{PackId ? 'Update' : 'Save'}</Button>
                    </div>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '60vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {formState?.config_type === "Normal" ? tableView() : AssortTableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}